module.exports = __webpack_public_path__ + "img/snakedeath.042ba96f.png";